import {NavigationProps} from "../constants/Props";
import {observer} from "mobx-react";
import Screen from "../components/Screen";
import Box from "../components/Box";
import {isMobile} from "react-device-detect";
import Title from "../components/Title";
import {toI18N} from "../utils/I18n";

import React, {useEffect} from "react";
import {IGroupStore} from "../stores/GroupStore";
import {IDeeplinkStore} from "../stores/DeeplinkStore";
import {LINK_TYPE_COMMUNITY_PAGE, LINK_TYPE_INVITATION_PAGE} from "./LinkDetailsScreen";
import {usePrevious} from "../utils/HooksHelper";
import * as Analytics from "../utils/Analytics";

interface Props extends NavigationProps {
    store: IGroupStore,
    linkStore: IDeeplinkStore,
}

export const GROUP_TYPE_OPEN = 'open';
export const GROUP_TYPE_RESTRAINT = 'restraint';
export const GROUP_TYPE_PRIVATE = 'private';

function HLPrivacySettingScreen(props: Props) {
    const {
        onBack,
        onNext,
        store,
        linkStore,
        isActive,
    } = props;

    const prevIsActive = usePrevious(isActive);
    useEffect(() => {
        if (!prevIsActive && isActive) {
            Analytics.logEvent(Analytics.events.land_on_choose_group_type_page);
        }
    });

    const onValueChange = (event: any) => {
        switch (event.target.value) {
            case GROUP_TYPE_OPEN:
                store.setIsGroupHistoryOn(true);
                store.setIsMembersCanPostOn(true)
                store.setIsOpen(true);
                store.setShareToPublic(true);
                store.setAllowCrossExposure(true);
                linkStore.setHasInviter(true);
                linkStore.setExpiration('')
                linkStore.setLinkType(LINK_TYPE_COMMUNITY_PAGE)
                linkStore.setIsDefault(true);
                linkStore.setIsPrivate(false);
                break;
            case GROUP_TYPE_RESTRAINT:
                store.setIsGroupHistoryOn(true);
                store.setIsMembersCanPostOn(true)
                store.setIsOpen(false);
                store.setShareToPublic(false);
                store.setAllowCrossExposure(true);
                linkStore.setHasInviter(true);
                linkStore.setExpiration('')
                linkStore.setLinkType(LINK_TYPE_COMMUNITY_PAGE)
                linkStore.setIsDefault(true);
                linkStore.setIsPrivate(false);
                break;
            case GROUP_TYPE_PRIVATE:
                store.setIsGroupHistoryOn(false);
                store.setIsMembersCanPostOn(true)
                store.setIsOpen(false);
                store.setShareToPublic(false);
                store.setAllowCrossExposure(false);
                linkStore.setHasInviter(false);
                linkStore.setExpiration('')
                linkStore.setLinkType(LINK_TYPE_INVITATION_PAGE)
                linkStore.setIsDefault(false);
                linkStore.setIsPrivate(true);
                break;
        }
        store.setGroupType(event.target.value)
    };

    return (
        <Screen title={"hl_privacy_setting_screen_header_title"} disabledKeyDown
            subtitle={"hl_privacy_setting_screen_header_subtitle"} onBack={onBack} onNext={onNext}>
            <Box grow center topMargin={isMobile ? 45 : 100}> <Title lg shrink
                title={toI18N('hl_privacy_setting_title')}/> </Box>
            <Box shrink sideMargin>
                <label style={{display: 'flex', alignItems: 'center'}}>
                    <input
                        type="radio"
                        value={GROUP_TYPE_OPEN}
                        checked={store.groupType === GROUP_TYPE_OPEN}
                        onChange={onValueChange}
                        style={{marginRight: 12}}
                    />
                    <Title lg color={store.groupType === GROUP_TYPE_OPEN ? "#002b3b" : undefined} center={false}
                        title={toI18N("hl_privacy_setting_group_type_open")}/>
                </label>
            </Box>
            <Box grow/>
            <Box shrink sideMargin>
                <label style={{display: 'flex', alignItems: 'center'}}>
                    <input
                        type="radio"
                        value={GROUP_TYPE_RESTRAINT}
                        checked={store.groupType === GROUP_TYPE_RESTRAINT}
                        onChange={onValueChange}
                        style={{marginRight: 12}}

                    />
                    <Title lg color={store.groupType === GROUP_TYPE_RESTRAINT ? "#002b3b" : undefined} center={false}
                        title={toI18N("hl_privacy_setting_group_type_restraint")}/>
                </label>
            </Box>
            <Box grow/>
            <Box shrink sideMargin>
                <label style={{display: 'flex', alignItems: 'center'}}>
                    <input
                        type="radio"
                        value={GROUP_TYPE_PRIVATE}
                        checked={store.groupType === GROUP_TYPE_PRIVATE}
                        onChange={onValueChange}
                        style={{marginRight: 12}}
                    />
                    <Title lg color={store.groupType === GROUP_TYPE_PRIVATE ? "#002b3b" : undefined} center={false}
                        title={toI18N("hl_privacy_setting_group_type_private")}/>
                </label>
            </Box>
            <Box grow/>

        </Screen>
    )

}

export default observer(HLPrivacySettingScreen);
